import { ArrowRight, Phone } from 'lucide-react';
import { Link, useLocation, useParams } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ROUTES } from '@/constants/routes';

export function FinalCtaSection() {
  const location = useLocation();
  const { region } = useParams();

  return (
    <section className="bg-white">
      <div className="mx-auto w-full max-w-7xl px-4 pb-16 sm:px-6 sm:pb-24 lg:px-8">
        <div className="grid items-center gap-8 overflow-hidden rounded-3xl bg-gradient-to-r from-brand-700 via-brand-600 to-brand-500 px-6 py-10 sm:gap-10 sm:px-12 sm:py-16 lg:grid-cols-[1fr_auto] lg:gap-16 lg:px-16">
          <div>
            <h2 className="text-2xl font-bold leading-[1.15] tracking-tight text-white sm:text-4xl lg:text-[2.75rem]">
              Reserve a seat before the
              <br className="hidden sm:block" />{' '}
              cohort locks on May 24.
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-white/80 sm:mt-5 sm:max-w-lg sm:text-base">
              Two free weeks of in-person, small-group math.{' '}
              <span className="font-bold text-white">No card. No contract.</span>{' '}
              If it&rsquo;s not for you, walk away and we&rsquo;ll wish you a great school year.
            </p>
          </div>

          <div className="flex flex-col gap-3 sm:gap-4">
            <Button
              asChild
              className="group h-12 w-full cursor-pointer rounded-2xl bg-white px-6 text-base font-semibold text-brand-600 shadow-lg transition-all hover:bg-slate-50 sm:h-16 sm:w-auto sm:px-10 sm:text-lg"
            >
              <Link
                to={ROUTES.promotionEnrollment}
                state={{ from: location.pathname, region }}
              >
                1-Minute Enrollment
                <ArrowRight
                  className="ml-2 size-5 text-brand-600 transition-transform group-hover:translate-x-0.5"
                  aria-hidden="true"
                />
              </Link>
            </Button>

            <Button
              asChild
              className="h-12 w-full cursor-pointer rounded-2xl border-2 border-white/30 bg-transparent px-6 text-sm font-semibold text-white transition-all hover:border-white/50 hover:bg-white/10 sm:h-16 sm:w-auto sm:px-10 sm:text-lg"
            >
              <a href="tel:+19493002265">
                <Phone className="mr-2 size-4 shrink-0" aria-hidden="true" />
                <span className="truncate">or text Abraham &middot; (949) 300-2265</span>
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}